import React from 'react';

import {RequiredTaggingDialog} from './dialogs/requiredTaggingDialog';
import {useSafetyNets} from './safetyNetsContext';

/*
 * Props.
 */

interface RequiredTaggingCoordinatorProps {}

/*
 * Component.
 */

export const RequiredTaggingCoordinator: React.FC<RequiredTaggingCoordinatorProps> = (props) => {
  const {shouldShowBlockingModal, onHideBlockingModal, maybeAction} = useSafetyNets();

  if (!shouldShowBlockingModal || !maybeAction) {
    return null;
  }

  return <RequiredTaggingDialog onHideBlockingModal={onHideBlockingModal} safetyNetAction={maybeAction} />;
};
